import React from 'react'

import classnames from 'classnames'

import { getPreviewSrcSetData } from '../itemCard/photoduneGridItemCard/imgUrls'
import FavoriteButton from '../buttons/favoriteButton/favoriteButton'
import itemAspectRatio from '../../../common/utils/itemAspectRatio'

import styles from './itemDetails.module.css'

const Preview = ({ item, rank, isInFavourites, onAddToFavourites }) => {
  const aspectRatio = itemAspectRatio(item) || 1.0
  const { sizes, srcSet, defaultImage } = getPreviewSrcSetData(
    item.image_urls,
    'w700',
    aspectRatio
  )

  const isImageWide = aspectRatio > 1.2

  const previewWrapperStyle = classnames(
    [styles.previewImageWrapper],
    { [styles.wideImageWrapper]: isImageWide },
    { [styles.standartImageWrapper]: !isImageWide }
  )
  return (
    <div data-test="itemDetails" className={styles.previewContainer}>
      <div className={styles.itemLinkWrapper}>
        <div className={previewWrapperStyle}>
          <img
            sizes={sizes}
            srcSet={srcSet}
            src={defaultImage.url}
            title={item.name}
            alt={item.name}
            className={styles.image}
          />
        </div>
        <a href={`${item.url}?s_rank=${rank}`} className={styles.previewLink} />
        <FavoriteButton
          href={`/favorites?item_id=${item.id}`}
          onClick={onAddToFavourites}
          isActive={isInFavourites}
          className={styles.favoriteButton}
        />
      </div>
    </div>
  )
}

export default Preview
